import { Component, OnInit } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-test-questions',
  templateUrl: './test-questions.component.html',
  styleUrls: ['./test-questions.component.scss']
})
export class TestQuestionsComponent implements OnInit {

  exam: IExam = examDefault;
  candidate: any;
  constructor(private popoverRef: PopoverRef<TestQuestionsComponent>,
    private examService: ExamService, private snackBar: SnackbarService, private router: Router,
    private serializer: UrlSerializer) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
    }
  }

  close() {
    this.popoverRef.close();
  }

  async testQuestions() {
    let data = { "ExaminationIDs": this.examService.selectedExamIds, "ExamNo": this.candidate, "SelectAllExam": this.examService.selectAll };

    await this.examService.testExam(data).then((res: any) => {
      this.snackBar.success('Exam questions tested successfully');
      this.popoverRef.close();
    }).catch((e) => {
      console.log(e);
      // this.snackBar.open(e, 'CLOSE', {
      //   duration: 3000,
      //   horizontalPosition: 'right', verticalPosition: 'top'
      // });
    });
  }
}
